import React from "react";
import {
  Checkbox,
  FormControlLabel,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@material-ui/core";

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

export const AfiliadoMenu = (props) => {

  const { afiliado, afiliadoExterno } = props;

  return (
    <React.Fragment>
      <Typography
        variant="h6"
        style={{
          textDecoration: "underline",
          textAlign: "center",
          margin: "1.5rem 0",
        }}
      >
        Información Afiliado
      </Typography>
      <Table style={{ width: "80%", margin: "auto" }}>
        <TableBody>
          <TableRow>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              Afiliado:
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              {afiliado?.apellido_y_nombre || afiliadoExterno?.apellidoNombre}
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              Email:
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              {afiliado?.domiciliosAfiliados?.mail || afiliadoExterno?.domiciliosAfiliados?.mail}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
            {afiliado ? "Cuil:" : "DNI:"}
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              {afiliado?.cuil || afiliadoExterno?.nroDocumento}
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              Telefono:
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              {afiliado?.domiciliosAfiliados?.telefono || afiliadoExterno?.domiciliosAfiliados?.telefono}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              Fecha de Nac:
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              {new Date(
                afiliado?.fecha_nacimiento || afiliadoExterno?.fechaNacimiento
              ).toLocaleString("es", optionsfecha)}
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              Celular:
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              {afiliado?.domiciliosAfiliados?.celular || afiliadoExterno?.domiciliosAfiliados?.celular}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <Grid
        style={{
          marginTop: "1rem",
          display: "flex",
          justifyContent: "space-evenly",
        }}
      >
        <FormControlLabel
          control={<Checkbox checked={afiliado?.incapacitado === 1} disabled />}
          label={
            <Typography style={{ color: "black" }}>Discapacitado</Typography>
          }
        />
        <FormControlLabel
          control={<Checkbox checked={afiliado?.judicializado === true} disabled />}
          label={
            <Typography style={{ color: "black" }}>Judicializado</Typography>
          }
        />
      </Grid>
    </React.Fragment>
  );
};
